var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQPlaySingle = function SvgQPlaySingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.975 11.134 8.188 5.72a.99.99 0 0 0-1.469.867v10.828a.99.99 0 0 0 1.47.867l9.786-5.415a.989.989 0 0 0 0-1.732",
    clipRule: "evenodd"
  })));
};
export { SvgQPlaySingle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3Ljk3NTIgMTEuMTM0Mkw4LjE4ODIyIDUuNzE4OEM3LjUyNzcgNS4zNTYyNCA2LjcxOTI0IDUuODMxMzIgNi43MTkyNCA2LjU4NTYxVjE3LjQxNDRDNi43MTkyNCAxOC4xNjg3IDcuNTI3NyAxOC42NDM4IDguMTg4MjIgMTguMjgxMkwxNy45NzUyIDEyLjg2NThDMTguNjU2NSAxMi40ODg2IDE4LjY1NjUgMTEuNTExNCAxNy45NzUyIDExLjEzNDJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";